/*
 *******************************************************************************
 *
 *  Filename:   @/utils/fetchApi.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Module for fetching API data.
 *
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *
 *  Created:    Friday, August 18, 2023 - 6:07 AM (CST)
 *
 *  Notes:
 *
 *  Revisions:
 *              2023/08/18  NJN Initial Build
 *
 *  Copyright (c) 2023 - Archetact Software - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import axios from "@/utils/axios";

export const fetchApi = async (awsFunc, action, parameters = {}) => {
  try {
    const accessToken = window.localStorage.getItem("accessToken");
    const response = await axios.post(
      "https://w4f2z4c35e.execute-api.us-east-1.amazonaws.com/dev/" + awsFunc,
      {
        action: action,
        parameters: parameters,
      },
      {
        headers: {
          Authorization: "Bearer " + accessToken,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};
